import React from 'react';
import { useParams } from '@reach/router';


const NeedMethodMessage = ({
  argLength
}) => {

  const params = useParams();

  const {
    currentMethod = '',
  } = params;

  // Check for zero parameters or no method selected

  if (!currentMethod) {
    return (
      <p>Select a method to show available parameters.</p>
    );
  } else if (argLength === 0) {
    return (
      <p>No parameters required.</p>
    );
  } else {
    return (
      // Return param list
      <div></div>
    );
  }

};

export { NeedMethodMessage };
